import { Box } from '@mui/material';

import EmailSyncAdminPageHeader from './EmailSyncAdminPageHeader';
import AdminEmailJobStatusStatistics from './AdminEmailJobStatusStatistics';
import AdminEmailObjectSyncedStatistics from './AdminEmailObjectSyncedStatistics';
import AdminEmailJobTable from './AdminEmailJobView/AdminEmailJobTable';

import { useDataGridState } from '../hooks/useDataGridState';
import { useEmailJobsPoller } from '../hooks/useEmailJobsPoller';
import { useLoaderData, useOutletContext } from 'react-router';

export { clientLoader } from './emailSyncAdminLoader';

const EmailSyncAdmin = () => {
	const { jobs: loaderJobs, users } = useLoaderData();
	const { tenant } = useOutletContext();

	const {
		parameters: initialQueryParams,
		handlePaginationModelChange,
		handleSortModelChange,
	} = useDataGridState();

	const { jobs, jobStatistics, jobCount, queryParams } = useEmailJobsPoller({
		loaderJobs,
		initialQueryParams,
	});

	const pageContainerStyles = {
		display: 'flex',
		flexDirection: 'column',
		rowGap: '16px',
		minHeight: '100vh',
		padding: '36px 26px',
		overflow: 'auto',
	};

	return (
		<>
			<Box sx={pageContainerStyles}>
				<EmailSyncAdminPageHeader tenantName={tenant.name} />
				<AdminEmailJobStatusStatistics jobStatistics={jobStatistics} />
				<AdminEmailObjectSyncedStatistics jobStatistics={jobStatistics} />

				<AdminEmailJobTable
					jobs={jobs}
					parameters={queryParams}
					jobCount={jobCount}
					handlePaginationModelChange={handlePaginationModelChange}
					handleSortModelChange={handleSortModelChange}
					users={users}
				/>
			</Box>
		</>
	);
};

export default EmailSyncAdmin;
